import { Component } from '@angular/core';

@Component({
  selector: 'app-unsupported-file-dialog',
  templateUrl: './unsupported-file-dialog.component.html',
  styleUrls: ['./unsupported-file-dialog.component.sass'],
})
export class UnsupportedFileDialogComponent {}
